export default {
    theme: { light: 'Light Theme', dark: 'Dark Theme' },
    login: {
    textCredenciais: 'Enter your credentials',
    acessLogin: 'Username',
    acessPassword: 'Password',
    lembrarSenha: 'Remember username and password',
    forgotPass: 'I forgot my password',
    Enter: 'Enter',
    escolhaApelido: 'Choose your nickname',
    descApelido: 'To continue, set a display nickname.'
  },
   registro: {
    titleRegister: 'Register',
    labelUsuario: 'Username',
    ruleUsuarioRequired: 'Username is required',
    labelApelido: 'Nickname',
    ruleApelidoRequired: 'Nickname is required',
    labelEmail: 'Email',
    ruleEmailRequired: 'Email is required',
    ruleEmailInvalid: 'Invalid email',
    labelSenha: 'Password',
    ruleSenhaRequired: 'Password is required',
    ruleSenhaMin: 'Minimum 8 characters',
    ruleSenhaLetter: 'Use at least one letter',
    ruleSenhaNumber: 'Use at least one number',
    ruleSenhaSymbol: 'Use at least one symbol',
    strengthFraca: 'Weak',
    strengthMedia: 'Medium',
    strengthForte: 'Strong',
    labelRepeatPassword: 'Repeat Password',
    ruleConfirmationRequired: 'Confirmation is required',
    rulePasswordsMatch: 'Passwords do not match',
    btnRegister: 'Register',
    alertSuccess: 'Pending account created! Check your confirmation code.'
  },
  download: {
    title: 'Download our client now',
    btnDownload: 'Download'
  },
  characters: {
    title: 'My Characters',
    youHave: 'You have {count} character(s).',
    noCharacters: 'You do not have any characters.',
    classLabel: 'Class:',
    levelLabel: 'Level:',
    goldLabel: 'Gold:',
    silverLabel: 'Silver:',
    bronzeLabel: 'Bronze:',
    createdLabel: 'Created:',
    rebirthsLabel: 'Rebirths:',
    bannedLabel: 'Banned:',
    yes: 'Yes',
    no: 'No'
  },
    menu: {
      home: 'Home',
      login: 'Log In',
      register: 'Register',
      download: 'Download',
      discord: 'Discord',
      info: 'My Info',
      changePassword: 'Change Information',
      inbox: 'Inbox (in development)',
      market: 'Shopping Zephyr',
      coinsBr: 'Zephyr Coins Brazil',
      coinsInt: 'Zephyr Coins International',
      wikia: 'Zephyr Wikia',
      ranked: 'Ranked Score',
      alquimia: 'Create Alchemy',
      atts: 'Release Notes',
      roulette: 'Lucky Roulette',
      daily: 'Daily Collect',
      loggedAs:'Logged in as',
      casino: 'Zephyr Casino (in development)',
      escala: 'Zephyr Scale',
      logout: 'Log Out'
    },
    snackbar: { newMessages: 'You’ve got {count} new message(s)!' },
    footer:   { copy: '{site} - All rights reserved' },
    hero: {
      title:    'Grand Fantasia Zephyr',
      subtitle: 'the best private Grand Fantasia server'
    },
    chat: { greeting: 'Hello! We’re excited to have you, access our discord!' },
  
    ranks: {
      title:        'HIGHLIGHTS',
      currentMonth: 'Month: {month}',
      deaths:       'Top Deaths',
      crystalDamage:'Top Crystal Damage',
      heal:         'Top Heal',
      playerDamage: 'Top Player Damage',
      wins:         'Top Wins',
      noData:       '— no data'
    },
  
    changeCreds: {
      greeting1: 'Looks like you’re not very secure haha…',
      greeting2: 'You can change your credentials',
      ninjaAlt:  'Ninja',
  
      newEmail: {
        label: 'New Email (!)',
        hint:  'You’re not required to change your email; do it if you want.'
      },
      currentPassword: { label: 'Current Password' },
      newPassword:     { label: 'New Password' },
      confirmPassword: { label: 'Repeat New Password' },
  
      updateButton: 'Update',
  
      emailConfirmModal: {
        title:        'Confirm your email',
        emailField:   { label: 'Enter your current email' },
        cancelButton: 'Cancel',
        confirmButton:'Confirm'
      },
  
      validation: {
        emailInvalid: 'Invalid email format',
        emailRequired:'Email is required'
      },
  
      error: {
        noChange:        'You can only proceed by changing email or password.',
        fillPassword:    'Fill in all password fields.',
        passwordMismatch:'New passwords do not match.',
        passwordLength:  'New password must be at least 8 characters.'
      },
  
      success: {
        updated: 'Credentials updated successfully!'
      }
    },
    inbox: {
        title:           'Inbox ({count} pending)',
        loginRequired:   'You must be logged in to view your messages.',
        from:            'from {sender}',
        gold:            '{amount} Gold 🟨',
        silver:          '{amount} Silver ⚪',
        bronze:          '{amount} Bronze 🟤',
        item:            'Item: {name}'
      },
      wiki: {
        searchPlaceholder: 'Type to search for an item…',
        loading:           'Loading…',
        itemIconAlt:       'Item icon {name}',
        setItemsTitle:     'Set Items',
        setBonusesTitle:   'Set Bonuses',
        recipeTitle:       'Crafting Recipe',
        recipeQty:         'Quantity: {qty}',
        obtainTitle:       'How to Obtain',
        closeButton:       'Close'
      },
      rank: {
        selectGroupLabel: 'Select Grouping',
        none:             '— none —',
        loading:          'Loading...',
        position:         'Position',
        name:             'Name',
        level:            'Level',
        class:            'Class',
        rebirth:          'Rebirth',
        reincarnated:     'Reincarnated',
        notReincarnated:  'Not Reincarnated',
    
        ranks: {
          deaths:        'Deaths Rank',
          crystalDamage: 'Crystal Damage Rank',
          heal:          'Heal Rank',
          playerDamage:  'Player Damage Rank',
          wins:          'Wins Rank'
        },
    
        stat: {
          deaths:        'Deaths',
          crystalDamage: 'Crystal Damage',
          heal:          'Heal',
          playerDamage:  'Player Damage',
          wins:          'Wins'
        }
      },
       
    alchemy: {
        title:           'Hello! Welcome, submit your alchemy suggestion',
        alt:             'Alchemy image',
        roundLabel:      'Round {n}:',
        itemPlaceholder: 'Item ID {n}',
        sendButton:      'Send Suggestion to Discord',
        loginError:      'You need to be logged in.',
        successMessage:  'Suggestion sent successfully!',
        sendError:       'Error sending suggestion.',
        inserirLote: 'Bulk insert',
        idItem:      'Enter the item ID',

         regras: {
        title: 'Rules!',
        forbiddenIntro: 'Not allowed:',
        forbiddenItems: 
          'island consumables tower or kaos stones tarot equipment and special invasion drops, such as emissary cores equipment (set, weapon, ring and cloak) of any kind alchemia-s exclusive items top rw and items released less than 2 months ago NT items from the last round',
        conclusion: 'All alchemies will be evaluated; if you break the rules, they will not be validated.'
      }
    },
    
    escala: {
    // Títulos principais
    title: 'Prize Tier',
    subtitle: 'Tier for {currentMonthName} – closing in: {timeRemaining}',
    spent: 'You have spent {spentPoints} points',
    chooseYourRescue: 'Choose your reward',

    // Botão “extra eligible”
    btnExtraEligible: 'You have rank items to redeem',

    // Tier card (os nomes “Bronze”, “Silver” etc. ficam no data original)
    redeemed: 'Redeemed',
    redeem: 'Redeem',

    // No card de pacote
    bundlePackage: 'Item bundle:',
    noDescription: '[No description]',

    // Ranking
    topDonorsTitle: 'Our Top 10 Donors of the Month',
    columnPlayer: 'Player',
    columnSpent: 'Spent',

    // Prêmios extras
    extraRewardsTitle: 'Extra rewards for our top donors',
    youAre: 'You are in {rank}ᵗʰ place!',
    availablePrizes: 'Prizes available:',
    availablePrize: 'Prize available:',
    clayX: 'Clay ×{quantity}',
    surpriseGMClick: 'GM Surprise (click to choose)',
    instruction: 'The above items are extra rewards for our best donors. Don’t miss out.',

    // Botões genéricos
    cancel: 'Cancel',
    redeemSurprise: 'Redeem Surprise',

    // Títulos de diálogos
    chooseYourSurprise: 'GM Surprise: choose your item',
    chooseYourExtraSurprise: 'GM Surprise (Extra Reward): choose your item',
    rescueExtraTitle: 'Extra Reward Redemption'
  },
  service: {
    title: 'Request Service',
    selectServiceLabel: 'Select service',
    options: {
      changeCharacterName: 'Change Character Name',
      recoverItem: 'Recover Item',
      changeGuildName: 'Change Guild Name',
      recoverDeletedChar: 'Recover Deleted Character'
    },
    selectCharLabel: 'Select character',
    newCharacterNameLabel: 'New Character Name',
    lostItemIdLabel: 'Lost Item ID',
    newGuildNameLabel: 'New Guild Name',
    deletedCharNameLabel: 'Deleted Character Name',
    buttonRequest: 'Request',
    errors: {
      notAuthenticated: 'User not authenticated.',
      selectCharAndName: 'Select a character and enter the new name.',
      informItemId: 'Enter the item ID.',
      informNewGuildName: 'Enter the new guild name.',
      informDeletedCharName: 'Enter the deleted character name.'
    },
    success: 'Request sent successfully!'
  },
  zephyr: {
    title: 'Acquire Zephyr Points (Purchase made with Brazilian currency)',
    labelAmountReal: 'Amount in Reais',
    willReceive: 'You will receive:',
    coins: 'Zephyr Coins',
    buttonBuy: 'Buy',
    errorPositive: 'Please enter an amount greater than zero.',
    errorPayment: 'Could not initiate payment. Please try again.',
    docTitle: 'Grand Fantasia Zephyr'
  },
  acquire: {
    title: 'Purchase Zephyr Points (Purchase made with international currency)',
    labelValueReal: 'Amount in Reais',
    receive: 'You will receive:',
    coins: 'Zephyr Coins',
    approxUSD: 'Approximately {usd} USD',
    sendOrderButton: 'Send Order',
    alertValueGreaterZero: 'Please enter an amount greater than zero.',
    alertLogin: 'Please log in to continue.',
    alertSuccess: 'Order placed! You will receive {coins} Zephyr Coins (≈ {usd} USD).',
    alertError: 'Could not place the order. Please try again.'
  },
  daily:{
    title:'Daily reward',
    subtitle:'Claim your daily reward today',
    rescue:'Rescue'
  },
  roulette: {
    headerTitle: 'Zephyr Lucky Wheel',
    headerSubPoints: 'Wheel price: 500 Zephyr points',
    headerSubBonus: 'Wheel price: 1000 Zephyr bonus',
    user: 'User',
    pointsLabel: 'Points',
    bonusLabel: 'Bonus',
    title: 'Lucky Wheel',
    spinButtonAlt: 'Spin',
    insufficientTitle: 'Insufficient Balance',
    insufficientMessage: 'You need {cost} Zephyr points to spin.',
    close: 'Close',
    congratsTitle: 'Congratulations!',
    congratsMessage:
      'Congratulations, you won {quantity}x {name}. Check the in-game shop and redeem your prize.'
  }
  }
  